module.exports = __webpack_public_path__ + "media/images/lb/261-922e2869190f49edcaf5c6f75d74b00f.svg";